<div
  class="button button__add"
  (click)="addNewEncounter()"
  title='Add a new encounter'>+</div>